import styled from 'styled-components';

const SectionHeader = styled.h4`
    padding: 8px 12px;
    border-radius: 4px;
    background-color: #eef0f2;
    color: #697d90;
    font-size: 11px;
    font-weight: 700;
    line-height: 15px; /* 136.364% */
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 8px;
`;

export default SectionHeader;
